import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
  Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js';
import moment from 'moment'
import {
  BasicSelect
} from 'vue-search-select';
import VueElementLoading from 'vue-element-loading'
import Printd from 'printd'
import VueBarcode from 'vue-barcode'
import PageTracker from '../../../common/PageTrackerHelper';
import pendingPods from '../common/pendingPods'
import pendingGroupIdShipments from '../common/pendingGroupIdShipments'
import {
  SeqofNonAllocation as GetNonAllocationSEQ,
  SubmitReason1 as StoreReason,
} from '../../../../services/modules/newallocationservices.js'
import keycloak from '../../../common/Keycloak';
import { applySmartInputStyles, clearSmartInputStyles, createClearInputWatcher } from "../../../common/inputStyleHelper";
import dummyInput from '../common/smartInput.vue'

export default {
  name: 'Allocation',
  components: {
    Paginate,
    DatePicker,
    BasicSelect,
    VueElementLoading,
    'barcode': VueBarcode,
    'pending-Pods' : pendingPods,
    'pending-group-id-shipment' : pendingGroupIdShipments,
    'dummy-input': dummyInput
  },
  mixins:[PageTracker],
  data: function() {
    return {
      barcodeValue: '11419106696',
      tripTitle:'Start Trip',
      srId:'',
      srList:[],
      srItemObj:{ value: "",text: ""},
      vehicleNo:'',
      vehicleOpenKM:'',
      deliveryOptionList:[{ text: "RTO/DTO"},{ text: "Delivery"},{ text: "RVP"}],
      deliveryOptionListTab: [{ text: "RTO" },{ text: "DTO" }, { text: "Delivery" }, { text: "RVP" }],
      deliveryOptionListPrint:[{ text: "RTO"},{ text: "DTO"},{ text: "RVP"},{ text: "Delivery"}],
      deliveryOptionItemObj:{ text: ""},
      deliveryOption:'',
      deliveryOptionItemObjPrint:{ text: ""},
      deliveryOptionPrint:'',
      clientOptionList:[],
      clientOptionItemObj:{ value: "",text: ""},
      clientOption:'',
      srHubName:'',
      srName:'',
      shipmentNo:'',
      startTripFlag:false,
      vehicleTypeFlag:false,
      vehicleType:'',
      srVehicleList:[],
      vehicleNoItemObj:{value:'', text: ''},
      startAllocationFlag:false,
      isAllocation:false,
      srShipmentList:[],
      pendingShipmentList:[],
      pendingShipmentListMdl:[],
      srArrayList:[],
      errVehicleNo:'',
      isRSVSr:0,
      errVehicleKm:'',
      closeTripModel:false,
      openKmImg:'',
      openKm:'',
      closeKmImg:'',
      closeKm:'',
      latitude:'',
      longitude:'',
      tripId: '',
      srVehicleNo:'',
      originCloseImg:'',
      errorCloseKM: '',
      tripState: '',
      vehicleVendorId: '',
      isVehicleReplaced: false,
      isVehicleReplacedCheck: 0,
      isLoadingASL:false,
      loader:'<div class="velmld-spinner"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20px" height="18px" viewBox="0 0 24 30" xml:space="preserve"><rect x="0" y="5.59869" width="4" height="19.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="10" y="9.59869" width="4" height="11.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="20" y="12.4013" width="4" height="6.19739" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate></rect></svg></div>',
      srLoader:'',
      isLoadingAlc:false,
      totalPendingShipment:0,
      pageCount: 0,
      pageNo: 1,
      pageNoMdl:1,
      pageCountMdl:0,
      isLoadingPSL:false,
      pendingShipModel:false,
      isLoadingPSLModel:false,
      totalPendingShipmentMdl:0,
      srIdFlt:'',
      srListFlt:[],
      srItemObjFlt:{ value: "",text: ""},
      srListFlt:[],

      fromListFlt:[
                    //{ value: null,text: "All"},
                  //  { value: "FromMob",text: "From Mobile"},
                    { value: "FromWeb",text: "From Web"}],
      fromItemObjFlt:{ value: "FromWeb",text: "From Web"},
      fromIdFlt:null,
      fromList:[{ value: "UA",text: "From Mobile"},{ value: "Web",text: "From Web"}],
      fromItemObj:{ value: "UA",text: "From Mobile"},
      fromId:"UA",
      srShipmentPrintList:[],
      isLoadingPrint:false,
      createdBy:'',
      srNameShipPrint:'',
      srPhoneShipPrint:'',
      flagShowPreviousShipment:false,
      showShipmentModel:false,
      showShipmentList:[],

      dismissSecs: 20,
      dismissCountDown: 0,
      allocationErrorMsg: "",
      dismissCountDownSuccess:0,
      allocationSuccessMsg: "",
      fieldErr:false,

      rtoDtoSheetTitle:'RTO Sheet',
      rtoDtoDrsTitle:'RTO DRS',
      rtoDRSBatchId:'',
      rtoDRSClientName:'',
      rtoDRSVendorName:'',
      rtoDRSWHHandOverPersonName:'',

      rtoRunSTHubName:'',
      rtoRunSTDrsNo:'',

      printDType:'',
      rvpShipmentsModel:false,

      fromToDate:'',
      fltpickup:'Pending',
      sAll: false,
      sAllMoreShip: false,
      selectedPickups: [],
      selectedPickupsMore:[],
      pickupList:[],
      SearchpickupList:[],
      pickupData:[{value:'Pending',text:'All Pending'},{value:'PendingNewPickUp',text:'Pending New PickUp To Assign'},{value:'PendingReAssigned',text:'Pending Re-Assign  For PickUp'}],
      pickupItem:{value:'Pending',text:'All Pending'},
      isChecked:false,
      isLoadingRvpPickup:false,
      errorRvpAllocation:'',
      successRvpAllocation:'',
      isAllocationRvp:false,
      suggestRVPArrayList:[],
      morePendingRVPShipmentsModel:false,
      isActiveRvp:false,
      searchByShippingId: '',
      PsearchByShippingId: '',
      RVPAllocatedShipmentList: '',
      indexTab: 1,
      ShipmentindexTab : 1,
      currentTab:'Allocated Shipment List',
      ActiveTabIndex: 0,
      ShipmentFutureFailedArrObj:[],
      ShipmentFailedArrObj: [],
      errorRvpAllocationErrorArrobj :[],
      isResetLoad : false,
      isConfirmLoad: false,
      allocationLoader: false,
      styleObjectsp : {
        'background-color' : 'red'
      },
      styleObjectE: {
        'background-color' : '#FF7E00'
      },
      tripCreatedDate: '',
      currentDateTime: '',
      tripDayflag: '',
      tripDateFlag: false,
      IsRVPPaperless: false,
      IsSRNeedTrip: true,
      searchByShippingIdRvp: '',
      searchByShippingIdRvpASL: '',
      batchIdPrint:'',
      batchIdListPrint:[],
      batchIdItemObjPrint:{ text: ""},
      ebnVehicleNo: '',
      errEbnVehicleNo: '',
      flagShowEbnVehicleNo: false,
      RVPLink:'',
      apiPath:'',
      disableFrom:false,
      errorOpenKM: '',
      disableBatchID:false,
      isLoadBatch:false,
      disableHTMLPDF:false,
      isLoadPDF:false,
      shippingIDArray:[],
      batchCreatedDate:'',
      today:'',
      futuredate:false,
      pastdate:false,
      PendingTabOptionKey: 0,
      PendingPopTabOptionKey: 0,
      PendingTabOptionKeyForLocus: 2,
      PendingPopTabOptionKeyForLocus: 0,
      mdlPopDeliveryOption: '',
      PopUpsearchByShippingId: '',
      PendingListdeliveryOpt: '',
      printType:'',
      showconfirmPrint : false,
      IsPaperlessFlyerbarcode: false,
      userid: '',
      errShipmentNo: '',
      isPodsLoader: false,
      isGroupIdLoader: false,
      showGroupIdShipmentModel: false,
      showParentGroupIdShipmentList: [],
      pendingGrouptErrorMsg: '',
      IsLongPinCodeFlag: null,
      setLocusFlag: false,
      holdTempMPSData: [],
      IsrvpMPSAllocation: false,
      mpsErrorLabel: 'Below highlighted shipments are from same mps group, Please allocate them to same SR.',
      hideAllocateFlag: true,
      vehicleNoRegExp :/^([A-Z|a-z]{2,3}\s{1}[0-9]{1,2}\s{1}[A-Z|a-z]{1,2}\s{1}\d{4})?([A-Z|a-z]{2}\s{1}[0-9]{1,2}[A-Z|a-z]{1}\s{1}[A-Z|a-z]{1,2}\s{1}\d{4})?([A-Z|a-z]{3}\s{1}\d{1,4})?([A-Z|a-z]{2,3}\s{1}[0-9]{2}\s{1}\d{4})?([A-Z|a-z]{2}\s{1}[0-9]{1,3}\s{1}[A-Z|a-z]{1,3}\s{1}\d{4})?$/,
      BucketName : '',
      TitleName :'',
                  Reason : '',
      ReasonObj : {
          text: ""
      },
      resultCount : 0,
      SEQShippingids :[],
      ReasonList : [],
      NonAllocationRsn : false,
      heaviesTitleName1:"",
      heaviesTitleName2:"",
      allocationMsgprexo : {},
      rvpPrexoShipmentList:[],
      rvpPrexoShipMsg: 'This is a PREXO shipment, and its associated Delivery shipment is :- ',
      rvpPrexoShipMsgBulk: 'You have allocated some prexo shipments, find below associated Delivery shipments :- ',
      userDataKey : '',
      hubCODPendingLimit: '',
      IsPendingCODBlock: false,
      isShowCODAmount: false,
      srCODPendingMsg: '',
      hvOnboardingFailMsg: '',
      hvSelieFailMsg: '',

      /* DRS Params */
      openDRSModel:false,
      drsbatchdetails:'',
      drsshipmentdetails:'',
      downloadUrl:'',
      drsflag: false,
      isShowDummyInput: false,
      styleData: {},
      dummyInputTimeout: 20000,
      activeTab: "",
      clientcheck: false,
      triggeredByDialog : false,
      isSVCEnabledForAdhocVehicles: false,
    }
  },
  watch: {
    shipmentNo: createClearInputWatcher('shipmentNo'),
  },
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    },
    jsUcfirst: function(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    batchCreatedDateFormat:function(date){
      if(date==null)return ''
      return moment(date).format('DD-MM-YYYY');
    }
  },
  async mounted() {
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    let validateUser = await this.validateJwtToken();

    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext)
    this.userHubId = userdetail.hubdetails[0] == undefined ? 0 : userdetail.hubdetails[0]
    this.createdBy = userdetail.username;
    this.userid = userdetail.userid;
    this.globalroutingflag = userdetail.globalroutingflag;

    //console.log("this.globalroutingflag>>>>>",this.globalroutingflag);
    this.setLocusFlag = await this.checkIsLocusEnableforhub()
    // this.setLocusFlag = false //above line UNCOMMENT ONCE LOCUS GOES ON LIVE

    const IsRVPPaperlessEncrypt = window.localStorage.getItem('IsRVPPaperless')
    const IsRVPPaperlessbytes = CryptoJS.AES.decrypt(IsRVPPaperlessEncrypt.toString(), this.userDataKey);
    const IsRVPPaperlessbytestext = IsRVPPaperlessbytes.toString(CryptoJS.enc.Utf8);
    const paperLessKey = JSON.parse(IsRVPPaperlessbytestext)
    //console.log('paperLessKey',paperLessKey);
    if(paperLessKey != null && paperLessKey.trim() == "1") {
      this.IsRVPPaperless = true;
      this.deliveryOptionListPrint.splice(2, 1) ;
    } else {
      this.IsRVPPaperless = false;
    }
    console.log('this.IsRVPPaperless',this.IsRVPPaperless);

    await this.getHubName(this.userHubId);
    this.loadSRList(this.userHubId);
    this.checkIsSVCAdhocVehiclesEnabled(this.userHubId)
    //this.vehicleNoRegExp = new RegExp('^[A-Z]{2}[ -][0-9]{1,2}(?: [A-Z])?(?: [A-Z]*)? [0-9]{4}$');

    if(this.userHubId==1091) {
      var fromListFlt = this.fromListFlt.filter(n => {
        if(n.value!=null) {
          return n
        }
      })
      this.fromListFlt = fromListFlt
      this.fromItemObjFlt = { value: 'FromWeb',text: "From Web"}
      this.fromIdFlt = 'FromWeb'
    }

    // if(this.userHubId == 4 || this.userHubId == 614) {
    //   this.deliveryOptionList.push({ text: "DTO"});
    // }

    // $(".shipmentListtab ul li:first").addClass("active");
    // console.log('test',$(".shipmentListtab ul li:first"));
    // this.getAllPendingShipmentList('reload', shipmentType);
    //console.log('Mixin is working for :',result);
    this.getAllocationconfigFlag()
  },
  updated() {
    if(this.ActiveTabIndex == 0){
      $('.shipmentListtab ul li a:first').addClass('active')
    }
  },
  computed: {
    flagAllocation() {
      if(this.deliveryOption=="Delivery" || this.deliveryOption=="RVP" || this.deliveryOption=="RTO" || this.deliveryOption=="DTO"  || this.deliveryOption=="RTO/DTO") {
        let checkSpecialChars = /[!@#$%^&*`'[+~/(),.?":{}|<>]/;
        if( checkSpecialChars.test(this.shipmentNo)==false){
          var isComplete = this.deliveryOption && this.shipmentNo
          this.errShipmentNo = '';

        } else {
          this.errShipmentNo = 'Please Enter Valid Shipment No.!'
        }
      }
      // if(this.deliveryOption=="Delivery") {
      //   var isComplete = this.deliveryOption && this.shipmentNo
      // } else {
      //   var isComplete = this.deliveryOption && this.clientOption && this.shipmentNo
      // }
      return isComplete
    },
    totalCODAmount() {
      var totalAmount = 0
      for (var i = 0; i < this.srShipmentPrintList.length; i++) {
        if(this.srShipmentPrintList[i].OrderType=="COD" || this.srShipmentPrintList[i].OrderType=="cod") {
          totalAmount += parseFloat(this.srShipmentPrintList[i].NetPayment)
        }
      }
      return totalAmount.toFixed(2);
    }
  },
  created() {
    // axios.interceptors.request.use((config) => {
    //   this.setLoading(true);
    //   return config;
    // }, (error) => {
    //   this.setLoading(false);
    //   return Promise.reject(error);
    // });
    //
    // axios.interceptors.response.use((response) => {
    //   this.setLoading(false);
    //   return response;
    // }, (error) => {
    //   this.setLoading(false);
    //   return Promise.reject(error);
    // });
  },
  methods: {
    getAllocationconfigFlag() {
      this.input = {"hubid": this.userHubId }
      axios({
          method: 'POST',
          url: apiUrl.api_url + 'exposeallocationapis/get/newallocation/configsettings',
          data: this.input
        })
        .then(result => {
          if (result.data.code == 200) {
            this.drsflag = result.data.drsflag;
            this.deliveryOptionList = [{ text: "RTO/DTO" }];
            this.deliveryOptionListTab = [{ text: "RTO" }, { text: "DTO" }];
            const { Deliveryflag, Rvpflag } = result.data.data;
            if (Deliveryflag == false) {
              this.deliveryOptionList.push({ text: "Delivery" });
              this.deliveryOptionListTab.push({ text: "Delivery" });
            }
            if (Rvpflag == false) {
              this.deliveryOptionList.push({ text: "RVP" });
              this.deliveryOptionListTab.push({ text: "RVP" });
            }

            if (this.setLocusFlag && this.globalroutingflag) {
              this.deliveryOptionList = this.deliveryOptionList.filter(item => item !== "Delivery");
              this.deliveryOptionListTab = this.deliveryOptionListTab.filter(item => item !== "Delivery");
            } else {
              this.setLocusFlag = false;
            }

            if (this.deliveryOptionList.length > 0) {
              let shipmentType = "";
              if (this.deliveryOptionList[0].text === 'RTO/DTO') {
                shipmentType = 'RTO';
              } else {
                shipmentType = this.deliveryOptionList[0].text;
              }
              this.onTabActivated(shipmentType)
            }
          }
        }, error => {
          console.error(error)
        })
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    countDownChangedSuccess(dismissCountDownSuccess) {
      this.dismissCountDownSuccess = dismissCountDownSuccess
    },
    getHubName(hubid) {
      return new Promise((resolve, reject) => {
        this.input = {
          hubids: [hubid]
        }
        axios({
            method: 'POST',
            url: apiUrl.api_url + 'expose/hubservicecenter/hubarray/get',
            data: this.input
        })
        .then(result => {
          if (result.data.data.code == 200) {
            //console.log('Result hub',result.data);
            this.hubName = result.data.data.data[0].HubName
            this.latitude = result.data.data.data[0].Latitude
            this.longitude = result.data.data.data[0].Longitude;
            const hubCodLimit = result.data.data.data[0].configSetting.CODPendingLimit;
            this.hubCODPendingLimit = (hubCodLimit && hubCodLimit != 0) ? hubCodLimit : null;
            this.IsPendingCODBlock = result.data.data.data[0].configSetting.IsPendingCODBlock;
          } else {
            this.hubName = '';
          }
          this.inputHub = {
            "Outsourceid":4,
            "hubid":this.userHubId
          }
          axios({
            method: 'POST',
            url: apiUrl.api_url + 'expose/hubservicecenter/getHubFlags',
            data: this.inputHub
          })
          .then(result => {
            if (result.data.data.code==200) {
              this.isRSVSr = result.data.data.data.IsRSVSr
            } else {
              this.$alertify.error(result.data.data.message)
            }
          }, error => {
            console.error(error)
          })
          resolve(true);
        }, error => {
          console.error(error)
        })
      })
    },
    loadSRList(hubid) {
      this.srLoader = this.loader
      this.srArrayList = []
      this.srList = []
      this.srListFlt = []
      if(hubid) {
        this.input = {
          "usertype":"3",
        	"hubid":[hubid],
          "isCODApiCall": this.IsPendingCODBlock ? true : false,
        }
        let apiendpoint = 'expose/users/HubDeliveryUsers/get/List';
        if (keycloak.enableKavach) {
          apiendpoint = 'user/migration/gethubdeliveryuserlist';
        }
        axios({
          method: 'POST',
          url: apiUrl.api_url + apiendpoint,
          data: this.input
        })
        .then(result => {
          //console.log('result.data',result.data.data.);
          if (result.data.data.code == 200) {
            this.srArrayList = result.data.data.results;
            this.hvOnboardingFailMsg = result.data.data.hvonboardingfailmsg;
            this.hvSelieFailMsg = result.data.data.hvselfiefailmsg;

            for (var i = 0; i < this.srArrayList.length; i++) {
              const srCODPendingAmt = this.srArrayList[i].codPendingAmount;
              const isDayAllocationDone = this.srArrayList[i].IsDayAllocationDone;
              let CodLimitBreachedFlag = !isDayAllocationDone && this.hubCODPendingLimit != null && srCODPendingAmt > 0 && srCODPendingAmt > this.hubCODPendingLimit;

              this.srList.push({
                value: this.srArrayList[i].userid,
                text: `${this.srArrayList[i].FirstName} ${this.srArrayList[i].LastName} (${this.srArrayList[i].OldDeliveryUserOrUserId}) (${this.srArrayList[i].userid})`,
                isCodLimitBreached: CodLimitBreachedFlag,
                codPendingAmt: srCODPendingAmt,
                isselfieverified: typeof(this.srArrayList[i].isselfieverified) != "undefined" ? this.srArrayList[i].isselfieverified : true,
                ishvonboardingdone: typeof(this.srArrayList[i].ishvonboardingdone) != "undefined" ? this.srArrayList[i].ishvonboardingdone : true,
              })
              this.srListFlt.push({
                value: this.srArrayList[i].userid,
                text: `${this.srArrayList[i].FirstName} ${this.srArrayList[i].LastName} (${this.srArrayList[i].OldDeliveryUserOrUserId}) (${this.srArrayList[i].userid})`
              })
            }
            //console.log('this.srList',this.srList);
          } else {
            this.$alertify.error(result.data.data.message?result.data.data.message:'No Record found')
          }
          this.srLoader = ''
        }, error => {
          this.srLoader = ''
          console.error(error)
        })
      } else {
        this.$alertify.error("Current Hub Id not found.")
      }
    },
    async selectSR(obj) {
      this.hideAllocateFlag=true;
      this.srCODPendingMsg = '';
      this.isShowCODAmount = false;
      this.ActiveTabIndex = 0;
      this.isVehicleReplacedCheck = 0
      this.isVehicleReplaced=false
      this.fieldErr = false
      this.startTripFlag = false
      this.deliveryOptionItemObj = { text: ""}
      this.deliveryOption = ""
      //this.pendingShipmentList = []
      //this.totalPendingShipment = 0
      this.srItemObj = obj
      this.srId = obj.value
      this.srName = obj.text
      this.vehicleTypeFlag = false
      this.flagShowEbnVehicleNo = false;
      this.ebnVehicleNo = '';
      this.shipmentNo = '';

      if(!obj.ishvonboardingdone || !obj.isselfieverified){
        let hyperVFailureMsg = !obj.ishvonboardingdone ? this.hvOnboardingFailMsg : this.hvSelieFailMsg;
        this.hideAllocateFlag = false;
        return this.$alertify.error(hyperVFailureMsg);
      }

      let eodDECValidation = await this.validateEODAllocation(this.srId, this.userHubId);
      if(eodDECValidation || obj.isCodLimitBreached){
        if(obj.isCodLimitBreached && !eodDECValidation){
          this.isShowCODAmount = true;
          this.dismissCountDown = this.dismissSecs;
          this.srCODPendingMsg = `<span style="color: red;"> Pending amount on SR: ${obj.codPendingAmt} <br/> Pending Amount Limit: ${this.hubCODPendingLimit} </span>`
        }
        let alertMsg = eodDECValidation ? eodDECValidation : 'Please clear the pending COD Amount against the user and try again.';
        this.tripTitle = 'Start Trip';
        this.tripDayflag = '';
        this.tripDateFlag = false;
        this.tripCreatedDate = '';
        this.hideAllocateFlag=false;
        return this.$alertify.error(alertMsg);
      }

      this.loadSrShipmentDetails('reload','delivery');

      if(this.setLocusFlag){
        this.PendingTabOptionKeyForLocus = 2;
        this.loadSrShipmentDetails('reload','rto');
      }

      var selectedSrDtl = this.srArrayList.filter(n=>{
        return n.userid==this.srId
      })
      //console.log('selectedSrDtl',selectedSrDtl);
      if(selectedSrDtl[0].EmpType==null || selectedSrDtl[0].EmpType=="") {
        this.fieldErr = true
        this.$alertify.error("EmpType not found against this SR, EmpType is required.")
        return false;
      } else {
        if(selectedSrDtl[0].isTripAllowedForSR == true) {
          this.IsSRNeedTrip = selectedSrDtl[0].isTripAllowedForSR;
          this.vehicleType = ""
          this.srVehicleList = []
          this.vehicleNoItemObj = {value:'', text: ''}
          this.vehicleOpenKM = ''
          this.vehicleNo = ''
          this.vehicleVendorId = 0
          this.startAllocationFlag = false
          this.tripTitle = 'Start Trip'
          this.errorCloseKM = ''
          this.errorOpenKM = ''
          this.closeKm = ''

          this.tripState= ''
          this.srShipmentList = []
          this.input = {
            "XBkey":"XB123",
            "HubId":this.userHubId,
            "DeliveryUserId":this.srId
          }
          axios({
            method: 'POST',
            url: apiUrl.api_url + 'expose/trip/tripDetails',
            data: this.input
          })
          .then(result => {
            if (result.data.TripState=="closed") {
              this.tripState='created'
              this.startTripFlag = true
              this.$alertify.error(result.data.message)
              this.tripDayflag = 0;
              this.tripDateFlag = false;
              this.loadSrShipmentDetails()
            } else if(result.data.TripState=="created" || result.data.TripState=="start") {
              this.tripCreatedDate = moment(result.data.TripCreatedDateTime).format('DD-MM-YYYY');
              this.currentDateTime = moment(result.data.CurrentDateTime).format('DD-MM-YYYY');
              if(this.tripCreatedDate == this.currentDateTime){
                //console.log('flag true');
                this.tripDayflag = 0;
                this.tripDateFlag = false;
              } else {
                this.tripDayflag = result.data.tripDayflag
                this.tripDateFlag = true;
              }
              this.tripState=result.data.TripState
              this.startTripFlag = true
              this.tripTitle = "Continue with existing trip"
              this.$alertify.error(result.data.message)
            } else if (result.data.TripState=="deliveryuserclosed" && result.data.code==200 ) {
              this.openKM = result.data.OpenKM
              this.openKmImg = result.data.OpenKMImageUrl
              this.closeKmImg = result.data.CloseKMImagUrl
              this.originCloseImg = result.data.CloseKMImagUrl
              this.tripId = result.data.TripId
              this.srVehicleNo = result.data.VehicleNo
              this.openKm = result.data.OpenKM
              this.closeTripModel = true
            } else {
              this.$alertify.error(result.data.message!='' && result.data.message!=undefined?result.data.message:'Not getting any response message')
            }

          }, error => {
            console.error(error)
          })
        } else {
         this.IsSRNeedTrip = selectedSrDtl[0].isTripAllowedForSR;
         this.srHubName = this.hubName;
         //this.loadSrShipmentDetails();
         this.tripCreatedDate = '';
         this.tripDayflag = 0;
         this.tripDateFlag = false;
         //this.$alertify.error('For selected SR not need to generate trip');
       }
      }
    },
    startTrip() {
      this.errVehicleNo = ""
      this.errVehicleKm = ""
      if(this.tripTitle=='Start Trip') {
        this.vehicleTypeFlag = true
      } else {
        this.startAllocation(false)
      }
    },
    loadVehicleDetails(type) {
      this.isVehicleReplacedCheck = 0
      this.isVehicleReplaced=false
      this.errVehicleNo = ""
      this.errVehicleKm = ""
      this.startAllocationFlag = false
      this.vehicleType = type
      this.srVehicleList = []
      this.vehicleNoItemObj = {value:'', text: ''}
      this.vehicleOpenKM = ''
      this.vehicleNo = ''
      this.vehicleVendorId = 0
      this.deliveryOptionItemObj = { text: ""}
      this.deliveryOption = ""
      if(type=="bike") {
        this.input = {
          "srid":this.srId,
          "hubid":this.userHubId
        }
        var url = apiUrl.api_url + "expose/getsrmapping"
      } else {
        const apiEndpoint = type == "vehicle" ? "expose/GetVendorVehiclesForLastMile" : "api/vehicle/get-adhoc-vehicles"
        this.input = {
          "HubId":this.userHubId
        }
        var url = apiUrl.api_url + apiEndpoint
      }
      axios({
        method: 'POST',
        url: url,
        data: this.input
      })
      .then(result => {

        if (result.data.data.ResultCode==100) {
          if(type=="vehicle") {
            var srVehicleList = result.data.data.Data
            //console.log('srVehicleList',srVehicleList);
            for (var i = 0; i < srVehicleList.length; i++) {
              this.srVehicleList.push({value:srVehicleList[i].VendorVehicleId,text:srVehicleList[i].VehicleNumber})
            }
          } else if(type=="adhoc"){
            let adhocVehicleList = result.data.data.Data;
            for (var i = 0; i < adhocVehicleList.length; i++) {
              this.srVehicleList.push({value:adhocVehicleList[i].VehicleNumber,text:adhocVehicleList[i].VehicleNumber})
            }
          } 
          else {
            var srVehicleList = result.data.data.data
            for (var i = 0; i < srVehicleList.length; i++) {
              this.srVehicleList.push({value:srVehicleList[i].VehicleNumber,text:srVehicleList[i].VehicleNumber})
            }
          }

        } else {
          if(type=="vehicle") {
            this.$alertify.error("No record found.")
          }
        }
      }, error => {
        console.error(error)
      })
    },
    selectVehicleNo(obj) {
      this.vehicleNoItemObj = obj
      this.vehicleNo = obj.text
      this.vehicleVendorId = obj.value
    },
    startAllocation(flag) {
      //console.log('flagg',flag);
      this.flagShowPreviousShipment = false
      this.startAllocationFlag = false
      this.errVehicleNo = ""
      this.errVehicleKm = ""
      var decimal=  /^\d+(\d{1,2})?$/;

      if(decimal.test(this.vehicleOpenKM)==false && this.vehicleNoRegExp.test(this.vehicleNo.toUpperCase())==false && flag && this.vehicleVendorId==0) {
          this.errVehicleNo = "Enter Correct Vehicle No"
          this.errVehicleKm = "Enter Correct KM"
      } else if(this.vehicleNoRegExp.test(this.vehicleNo.toUpperCase())==false && flag && this.vehicleVendorId==0) {
          this.errVehicleNo = "Enter Correct Vehicle No"
      } else if(decimal.test(this.vehicleOpenKM)==false && flag) {
          this.errVehicleKm = "Enter Correct KM"
      } else if( flag && this.vehicleOpenKM > 1000000) {
          this.errVehicleKm = "Open Km should be less than 1000000"
      } else {
        this.clientOptionItemObj = {value: "",text: ""}
        this.clientOption = ""
        this.shipmentNo = ''

        this.srName = this.srItemObj.text
        this.srHubName = this.hubName
        this.startAllocationFlag = true
        this.input = {
          "XBkey":"XB123"
        }
        axios({
          method: 'POST',
          url: apiUrl.api_url + 'expose/client/dropdown/list',
          data: this.input
        })
        .then(result => {
          if (result.data.code==200) {
            var clientOptionList = result.data.data
            for (var i = 0; i < clientOptionList.length; i++) {
              this.clientOptionList.push({value:clientOptionList[i].ClientMasterID,text:clientOptionList[i].CompanyName})
            }
          }
        }, error => {
          console.error(error)
        })
        if(flag){
          this.TripCreation();
        } else {
          this.deliveryOptionItemObj = { text: ""}
          this.deliveryOption = ""
        }
      }
    },
    TripCreation(){
      this.allocationLoader = true;
      let formData = {
        "XBkey":"XB123",
        "sruserid":this.srId.toString(),
        "hubid":this.userHubId,
        "km":this.vehicleOpenKM?this.vehicleOpenKM:0,
        "tripstate":this.tripState,//"created",
        "vehicleno":this.vehicleNo.toUpperCase(),
        "vehicletype":this.vehicleType,
        "triptype":this.deliveryOption,
        "srname":this.srName,
        "isvehiclereplaced":this.isVehicleReplaced,
        "operationType":"lastmile"
      }
      if((this.vehicleType=='bike' && this.srVehicleList.length==0) || this.isVehicleReplaced==true) {
        formData['isvehicleupdated'] = true
      } else {
        formData['isvehicleupdated'] = false
      }
      if(this.vehicleType=='vehicle') {
        formData['vehiclevendorid'] = this.vehicleVendorId
      }
      //console.log('formData',formData);

      axios({
        method: 'POST',
        url: apiUrl.api_url + 'expose/trip/create',
        data: formData
      })
      .then(result => {

        if (result.data.code==200) {
          let TrackerInfo = {
            projectname:"Last Mile",
            type:"Web",
            userid:this.userid,
            username:this.createdBy,
            meta: {
                "event" : "createTrip",
                "srname":this.srName,
                "triptype":this.deliveryOption,
                "hubid":this.userHubId
            }
          }
          this.PageTracker(TrackerInfo);
          this.startAllocationFlag = true;
          this.$alertify.success(result.data.message);
          if(this.deliveryOption=="RVP") {
            if(this.tripTitle == 'Start Trip'){
              this.isAllocationRvp = false;
              this.rvpShipmentsModel = true;
              this.pickupItem = {value:'Pending',text:'All Pending'}
              this.fltpickup = 'Pending'
              this.fromToDate = ""
              this.pickupList = []
              this.tabIndex  = 0;
              this.showPendingPickups();
            }
          }

        } else if(result.data.code == 202) {
          this.startAllocationFlag = false;
          this.$alertify.error(result.data.message.details[0].message);
        } else {
          this.startAllocationFlag = false;
          this.$alertify.error(result.data.message);
        }
        this.allocationLoader = false;
      }, error => {
        this.startAllocationFlag = false;
        this.$alertify.error('Failed to Create Trip, Please retry!');
        this.allocationLoader = false;
        console.error(error)
      })
    },

    checkIsSVCAdhocVehiclesEnabled(hubId){
      let payload = {
        "hubId": hubId
      }

      return axios({
        method: 'POST',
        url: apiUrl.api_url + 'api/vehicle/check-adhoc-vehicle-flag',
        data: payload
      })
      .then(result => {
        if (result.data.code == 200) {
          this.isSVCEnabledForAdhocVehicles = (result.data.data && result.data.data.isAllowed) ? result.data.data.isAllowed : false;
        }
      }, error => {
        this.isSVCEnabledForAdhocVehicles = false;
      })
    },

    isFlyerBarcodecheck(isPaperlessFlag,deliveryTpe){
      if( (isPaperlessFlag == true) && (deliveryTpe.toLowerCase() == 'rvp' || deliveryTpe.toLowerCase() == 'dto')) {
        this.IsPaperlessFlyerbarcode = this.IsRVPPaperless
      } else {
        this.IsPaperlessFlyerbarcode = false;
      }
    },
    selectDeliveryOption(obj) {
      this.flagShowPreviousShipment = false
      this.clientOptionItemObj = {value: "",text: ""}
      this.clientOption = ""
      this.deliveryOptionItemObj = obj;
      this.deliveryOption = obj.text;

      // Check if the selected shipment type exists in the srShipmentList
      const selectedShipTypes = (this.deliveryOption === 'RTO/DTO') ? ['RTO', 'DTO'] : [this.deliveryOption];
      const isAnyShipmentTypePresent = this.srShipmentList.some(shipment =>
        selectedShipTypes.includes(shipment.shipmenttype)
      );

      this.isAllocation = isAnyShipmentTypePresent;

      this.isFlyerBarcodecheck(this.IsRVPPaperless,this.deliveryOption);

      //this.loadSrShipmentDetails('reload');

      if(this.deliveryOption=="RVP") {
        //console.log('rvp test',this.IsSRNeedTrip,this.tripTitle);

        if( !this.IsSRNeedTrip || this.tripTitle != 'Start Trip') {
          this.rvpShipmentsModel = true;
        }
        this.isAllocationRvp = false;
        this.pickupItem = {value:'Pending',text:'All Pending'}
        this.fltpickup = 'Pending'
        this.fromToDate = ""
        this.pickupList = []
        this.tabIndex  = 0;
        this.onTabActivated(this.deliveryOption)
        //console.log('this.tripTitle ',this.tripTitle );
        //this.loadRVPAllocatedShipmentList()
      } else {
        this.onTabActivated(this.deliveryOption)
      }
    },
    selectClient(obj) {
      this.flagShowPreviousShipment = false
      this.clientOptionItemObj = obj
      this.clientOption = obj.value
    },
    selectFrom(obj) {
      this.fromItemObj = obj
      this.fromId = obj.value
    },
    async allocation() {
      if (!this.triggeredByDialog) {
        this.clientcheck = false;
      }
      this.triggeredByDialog = false;
      this.isShowDummyInput = false;
      let validateUser = await this.validateJwtToken() //validate expiration token
      if(this.flagShowEbnVehicleNo == true){
        if(this.vehicleNoRegExp.test(this.ebnVehicleNo.toUpperCase())==false) {
          return this.errEbnVehicleNo = 'Enter Correct Vehicle No';
        }
      }
      this.errEbnVehicleNo = "";
      this.allocationErrorMsg = ""
      this.allocationSuccessMsg = ""
      this.isLoadingAlc = true
      this.flagShowPreviousShipment = false
      var tempStr = this.shipmentNo
      var selectedSrDtl = this.srArrayList.filter(n=>{
        return n.userid==this.srId
      })
      this.input = {
        "XBkey":"XB123",
      	"HubId":this.userHubId.toString(),
      	"DeliveryUserId":this.srId,
      	"OldDeliveryUserOrUserId":selectedSrDtl[0].OldDeliveryUserOrUserId?selectedSrDtl[0].OldDeliveryUserOrUserId.toString():"0",
      	"DeliveryUserName":this.srName,
      	"ShippingID":(this.shipmentNo).trim(),
      	"LastModifiedBy":this.createdBy,
      	"IsConfirmAllocation":false,
      	"AllocationType":this.deliveryOption,
        "EmpType":selectedSrDtl[0].EmpType?selectedSrDtl[0].EmpType:"",
      	"MarkedFrom":"Web",//this.fromId,
      	"CourierCompanyID":selectedSrDtl[0].CourierCompanyID?selectedSrDtl[0].CourierCompanyID.toString():'null',
      	"IsRSVCSr":this.isRSVSr,
      	"MobileNo":selectedSrDtl[0].MobileNumber?selectedSrDtl[0].MobileNumber.toString():"",
        "isTripAllowedForSR": this.IsSRNeedTrip,
        "vehicleno": this.ebnVehicleNo
      }

      if(this.clientcheck){
        this.input.isSelfVendorPickup = true;
      }
      if(this.deliveryOption.toLowerCase() == 'dto') {
        this.input.IsRVPPaperless = this.IsRVPPaperless
      }

      if(this.IsLongPinCodeFlag != null) {
        this.input['IsLongPinCodeFlag'] = this.IsLongPinCodeFlag
      }
      //this.shipmentNo = ''

      //calculating related PREXO shipments type based upon input shipmentType
      let prexoShipmentType = (this.deliveryOption.toLowerCase() == 'delivery' && !['rto','dto','rto/dto'].includes(this.deliveryOption.toLowerCase())) ? 'RVP' : 'Delivery';

      axios({
        method: 'POST',
        url: apiUrl.api_url + 'expose/shipment/allocate',
        data: this.input
      })
      .then(result => {
        this.isShowDummyInput = true;
        this.styleData = result.data.lossCategorization;

        if (result.data.code==200) {
          //Hundle Prexo shipment success
          this.allocationMsgprexo  = result.data.prexoShipment ? ('This is a PREXO shipment, and its associated '+ prexoShipmentType +' shipment is :-'+ result.data.prexoShipment): null;
          let TrackerInfo = {
            projectname:"Last Mile",
            type:"Web",
            userid:this.userid,
            username:this.createdBy,
            meta: {
                "event" : "shipmentAllocation",
      	        "ShippingID":this.shipmentNo.trim().toString(),
                "IsRSVCSr":this.isRSVSr,
                "srname":this.srName,
                "AllocationType":this.deliveryOption,
                "isTripAllowedForSR": this.IsSRNeedTrip
            }
          }
          this.PageTracker(TrackerInfo);
          this.isAllocation = true
          this.shipmentNo = '';
          this.loadSrShipmentDetails()
          this.$refs.shipmentNo.focus()
          this.dismissCountDownSuccess = this.dismissSecs
          this.allocationSuccessMsg = tempStr+" :- "+result.data.message
          this.flagShowEbnVehicleNo = false;

          if(typeof result.data.status !=undefined && result.data.status==206 && result.data.data.length>1) {
            this.showGroupIdShipmentModel = true;
            this.pendingGrouptErrorMsg = result.data.mpsErrormsg;
            let pendingMPSData = result.data.data
            this.showParentGroupIdShipmentList = pendingMPSData.filter(obj => obj != tempStr);
          }

        } else {
          if(result.data.status && result.data.status==210){
            this.selfPickupClientDialog();
            this.isLoadingAlc = false
            return false;
          }
          this.ebnVehicleNo = '';
          this.flagShowEbnVehicleNo = false;
          if(typeof result.data.status !=undefined && result.data.status==204) {
            this.flagShowPreviousShipment = true
          }
          this.$refs.shipmentNo.focus();
          //this.shipmentNo = tempStr;

          if(typeof result.data.status !=undefined && result.data.status==207) {
            this.flagShowEbnVehicleNo = true;
            this.shipmentNo = tempStr;
            this.$refs.ebnVehicleNo.focus();
          }

          if (typeof result.data.status !=undefined && result.data.status==209) {
            this.ReAttemptLongPincodeAllocation(result);
          }

          this.dismissCountDown = this.dismissSecs
          this.allocationErrorMsg = result.data.message!='' && result.data.message!=undefined?`${tempStr} :-  ${result.data.message}`: `${tempStr} :- Not getting any response message.`

          //Hundle Prexo shipment error
          this.allocationMsgprexo  = result.data.prexoShipment ? ('This is a PREXO shipment, and its associated ' + prexoShipmentType + ' shipment is :-'+ result.data.prexoShipment) : null;
        }
        this.IsLongPinCodeFlag = null;
        this.isLoadingAlc = false
      }, error => {
        this.shipmentNo = tempStr
        this.isLoadingAlc = false
        console.error(error)
      })
    },
    ReAttemptLongPincodeAllocation(getResult){
      let message = {
        title: '',
        body: `<p><b>This shipment belongs to Long Pincode. Do you want to allocate it?</b></p>  <p style="color:green">Click <b> YES</b> to Attempt Delivery. <br/> <span style="color:red"> Press <b> No </b> to Hold the Shipment.</span> </p>`,
      };

      let res = this.$dialog.confirm(message, {
        html: true,
        animation: 'bounce',
        backdropClose: false,
        okText: 'Yes',
        cancelText: 'No',
        reverse: true
        //loader: true
      })
      .then(dialog => {
        this.IsLongPinCodeFlag = true;
        this.allocation();
      })
      .catch((e) => {
        this.IsLongPinCodeFlag = false;
        this.allocation();
      })
    },
    verifyTripClosed(userHubId,srId){
      return new Promise(async function(resolve,reject) {
        let inputData = {
          "XBkey":"XB123",
          "HubId":userHubId,
          "DeliveryUserId":srId
        }
        //console.log('this.input',inputData);
        axios({
          method: 'POST',
          url: apiUrl.api_url + 'expose/trip/tripDetails',
          data: inputData
        })
        .then(result => {
          //console.log('result.data.TripState',result.data.TripState);
          if (result.data.TripState =="deliveryuserclosed" && result.data.code == 200 ) {
            resolve(result.data);
          } else {
            resolve(false);
          }
        }, error => {
          console.error(error)
        })
      })
    },
    async confirmTrip() {
      let validateUser = await this.validateJwtToken() //validate expiration token
      if(this.deliveryOption == '') {
        this.$alertify.error('Please select delivery option type !');
        $('#deliveryOption').focus();
      } else {
        this.allocationSuccessMsg = ''
        this.isConfirmLoad = true;
        this.showParentGroupIdShipmentList = [];
        let verifyShipment = await this.verifyTripClosed(this.userHubId,this.srId);
        console.log('verifyShipment',verifyShipment);
        if(verifyShipment == false) {
          this.isAllocationRvp = false
          this.flagShowPreviousShipment = false
          this.srName = this.srItemObj.text
          this.srHubName = this.hubName
          this.startAllocationFlag = true
          this.input = {
            "XBkey":"XB123",
          	"sruserid":this.srId.toString(),
          	"hubid":this.userHubId,
          	"km":this.vehicleOpenKM?this.vehicleOpenKM:0,
          	"tripstate":this.tripState,//"created",
          	"vehicleno":this.vehicleNo.toUpperCase(),
          	"vehicletype":this.vehicleType,
          	"triptype":this.deliveryOption,
          	"srname":this.srName,
          	"isvehiclereplaced":this.isVehicleReplaced,
          	"LastModifiedBy":this.createdBy,
          	"MarkedFrom":this.fromId,
          	"operationType":"lastmile",
            "isHandoverDeliveryUser":1,
            "allocationType":this.deliveryOption
          }
          if((this.vehicleType=='bike' && this.srVehicleList.length==0) || this.isVehicleReplaced==true) {
            this.input['isvehicleupdated'] = true
          } else {
            this.input['isvehicleupdated'] = false
          }
          // if(this.tripTitle!='Start Trip') {
          //   this.input['isHandoverDeliveryUser'] = 1
          // }
          if(this.vehicleType=='vehicle') {
            this.input['vehiclevendorid'] = this.vehicleVendorId
          }
          //console.log('input',this.input);
          axios({
            method: 'POST',
            url: apiUrl.api_url + 'expose/shipment/confirm',
            data: this.input
          })
          .then(result => {
            if (result.data.code==200) {
              let TrackerInfo = {
                projectname:"Last Mile",
                type:"Web",
                userid:this.userid,
                username:this.createdBy,
                meta: {
                    "event" : "confirmShipment",
                    "sruserid":this.srId.toString(),
                    "km":this.vehicleOpenKM?this.vehicleOpenKM:0,
                    "triptype":this.deliveryOption,
                    "srname":this.srName,
                    "isvehiclereplaced":this.isVehicleReplaced,
                    "MarkedFrom":this.fromId,
                }
              }
              this.PageTracker(TrackerInfo);
              this.isAllocation = false
              this.$alertify.success(result.data.message)
              this.rvpShipmentsModel = false;
              this.resetTrip()
            } else {
              if(result.data.status == 208) {
                this.showGroupIdShipmentModel = true;
                this.pendingGrouptErrorMsg = result.data.message;
                this.showParentGroupIdShipmentList = result.data.data;
              } else {
                this.$alertify.error(result.data.message!='' && result.data.message!=undefined?result.data.message:'Not getting any response message.')
              }
            }
            this.isConfirmLoad = false;
          }, error => {
            console.error(error)
            this.isConfirmLoad = false;
          })
        }
        else {
          this.isConfirmLoad = false;
          this.openKM = verifyShipment.OpenKM
          this.openKmImg = verifyShipment.OpenKMImageUrl
          this.closeKmImg = verifyShipment.CloseKMImagUrl
          this.originCloseImg = verifyShipment.CloseKMImagUrl
          this.tripId = verifyShipment.TripId
          this.srVehicleNo = verifyShipment.VehicleNo
          this.openKm = verifyShipment.OpenKM
          this.closeTripModel = true
        }
      }
    },
    loadSrShipmentDetails(keywordClear='clear') {
      //this.ActiveTabIndex = 1;
      ///this.searchByShippingId = '';
      if(keywordClear == 'reload'){
        this.PsearchByShippingId = '';
        this.searchByShippingId = '';
      } else{
        this.PsearchByShippingId = '';
      }


      this.srShipmentList = []
      if(this.srId) {
        this.isLoadingASL = true
        this.input = {
          "HubId": this.userHubId.toString(),
          "DeliveryUserId": this.srId
        }
        if(this.deliveryOption!="") {
          this.input["ShipmentType"] = this.deliveryOption
        }
        if(this.searchByShippingId !="") {
          this.input["ShippingId"] = this.searchByShippingId.trim()
        }
        axios({
          method: 'POST',
          url: apiUrl.api_url + 'expose/get/allocate/shipment/sr/details',
          data: this.input
        })
        .then(result => {
          if (result.data.code==200) {
            this.srShipmentList = result.data.data;
            // if(this.srShipmentList.length >= 1) {
            //   this.isAllocation = true
            // }
          } else {
            this.isAllocation = false
          }
          this.isLoadingASL = false
        }, error => {
          this.isLoadingASL = false
          console.error(error)
        })
      }
    },
    PendingShipmentDetailsOnkeyDown(event){
      console.log('event');
      if(event.keyCode === 13) {
        this.loadPendingShipmentList('search','');
      }
    },
    loadPendingShipmentList(PkeywordClear='reload',DeliveryTabOption='', pageNo= 1) {
      //if(this.deliveryOption!="" || DeliveryTabOption !='' ) {
        if(PkeywordClear == 'reload'){
          this.PsearchByShippingId = '';
          this.searchByShippingId = '';
        } else {
          this.searchByShippingId = '';
        }

        this.isLoadingPSL = true
        this.pendingShipmentList = []
        this.pageNo = pageNo;
        if(this.deliveryOption != ''){
          this.PendingListdeliveryOpt = this.deliveryOption.toLowerCase() == 'rto/dto' ? 'RTO' : this.deliveryOption;
          this.checkOptionTypeForTab(this.deliveryOption);
          if(this.setLocusFlag){
            this.checkOptionTypeForTabForLocus(this.deliveryOption);
          }
          this.isFlyerBarcodecheck(this.IsRVPPaperless,this.deliveryOption);
        }
        if(DeliveryTabOption != '') {
          this.PendingListdeliveryOpt = DeliveryTabOption;
          this.checkOptionTypeForTab(DeliveryTabOption);
          if(this.setLocusFlag){
            this.checkOptionTypeForTabForLocus(DeliveryTabOption);
          }
          this.isFlyerBarcodecheck(this.IsRVPPaperless,DeliveryTabOption);
        }

        if(this.PendingListdeliveryOpt.toLowerCase() == 'delivery'){
          this.PendingListdeliveryOpt = 'Forward';
        }

        if(this.PendingListdeliveryOpt.toLowerCase() == 'rto/dto' && this.PendingTabOptionKey == 3){
          this.PendingTabOptionKey = 3;
          this.PendingListdeliveryOpt = 'RTO';
        }
        else if(DeliveryTabOption != '') {
          this.PendingListdeliveryOpt = DeliveryTabOption.toLowerCase() == 'delivery' ? 'Forward' : DeliveryTabOption;
          if(DeliveryTabOption.toLowerCase() == 'delivery') {
            this.PendingTabOptionKey = 0;
          } else if(DeliveryTabOption.toLowerCase() == 'rvp') {
            this.PendingTabOptionKey = 1;
          } else if(DeliveryTabOption.toLowerCase() == 'dto') {
            this.PendingTabOptionKey = 2;
          } else if(DeliveryTabOption.toLowerCase() == 'rto') {
            this.PendingTabOptionKey = 3;
          }
        }

        this.input = {
          "HubID": this.userHubId.toString(),
          "ShipmentType":this.PendingListdeliveryOpt,
          "PageNo":this.pageNo
        }
        if(this.PsearchByShippingId !="") {
          this.input["ShippingId"] = this.PsearchByShippingId.trim()
        }
        //console.log('this.input',this.input);
        axios({
          method: 'POST',
          url: apiUrl.api_url + 'expose/get/pending/shipment/details',
          data: this.input
        })
        .then(result => {
          if (result.data.code==200) {
            this.pendingShipmentList = result.data.data
            this.totalPendingShipment = result.data.Total
            if (this.totalPendingShipment < 20) {
              this.pageCount = 1
            } else {
              this.pageCount = Math.ceil(this.totalPendingShipment / 20);
            }
          } else{
            this.pageCount = 0;
          }
          this.isLoadingPSL = false
        }, error => {
          this.isLoadingPSL = false
          console.error(error)
        })
      //}
    },
    getPaginationData(pageNum) {
      this.pageNo = pageNum;
      this.loadPendingShipmentList('reload', this.PendingListdeliveryOpt, this.pageNo);
    },
    getAllPendingShipmentList(searchType, legType){
      if (this.$refs.paginate != undefined) {
        this.$refs.paginate.selected= 0;
      }

      if(legType == "RVP" && this.setLocusFlag){
        this.showPendingPickups();
      } else {
        this.loadPendingShipmentList(searchType, legType);
      }
    },
    closeCloseTripModel() {
      this.closeTripModel = false
    },
    loadOpenImageError(imageSrc, type) {
      var srcLink = "static/img/defaultImg.png"
      // var splitLink = imageSrc.split("id=")
      // if(splitLink.length>0) {
      //   if(splitLink[1]) {
      //     var srcLink = "https://drive.google.com/uc?export=view&id="+splitLink[1]
      //   }
      // }
      this.openKmImg = srcLink
    },
    loadCloseImageError(imageSrc) {
      var srcLink = "static/img/defaultImg.png"
      this.originCloseImg = imageSrc
      this.closeKmImg = srcLink
    },
    getCloseModelEvent(obj){
      this.rvpShipmentsModel = false
    },
    verifyTrip() {

      if(this.openKm >= 1000000){
        this.errorOpenKM = "Open Km should be less than 1000000";
      } else {
        this.errorOpenKM = '';
        if(parseFloat(this.closeKm) > parseFloat(this.openKm) ) {
          let calculatekm = parseFloat(this.closeKm) - parseFloat(this.openKm);
          if(calculatekm < 200) {
            this.errorCloseKM = '';
            this.input = {
              "XBkey":"XB123",
              "tripid":this.tripId,
              "sruserid":this.srId.toString(),
              "hubid":this.userHubId,
              "km":this.closeKm,
              "Openkm":this.openKm,
              "tripstate":"closed",
              "vehicleno":this.srVehicleNo,
              "isvehiclereplaced":false,
              // "latitude":this.latitude,
              // "logitude":this.longitude,
              //"speedmeterurl":this.originCloseImg,
              "lastmodifiedby":this.createdBy,
              "operationType":"lastmile"
            }
            //console.log('this.input',this.input);
            axios({
              method: 'POST',
              url: apiUrl.api_url + 'expose/trip/close',
              data: this.input
            })
            .then(result => {
              if (result.data.code==200) {
                let TrackerInfo = {
                  projectname:"Last Mile",
                  type:"Web",
                  userid:this.userid,
                  username:this.createdBy,
                  meta: {
                      "event" : "closeTrip",
                      "tripid":this.tripId,
                      "sruserid":this.srId.toString()
                  }
                }
                this.PageTracker(TrackerInfo);
                this.$alertify.success(result.data.message)
                this.resetTrip()
                this.closeTripModel = false
              } else {
                this.$alertify.error(result.data.message)
              }
            }, error => {
              console.error(error)
            })
          } else {
            this.errorCloseKM = "Travel distance cannot be more than 200 KM/day.!";
          }
        } else {
          this.errorCloseKM = "Close KM should be greater then open KM"
        }
      }
    },
    isVehicleReplaceCheck(event) {
      this.vehicleNoItemObj = {value:'', text: ''}
      this.vehicleNo = ''
      this.vehicleVendorId = 0
      if(event==1) {
        this.isVehicleReplaced=true
      } else {
        this.isVehicleReplacedCheck = 0
        this.isVehicleReplaced=false
      }
    },
    removeShipment(shippingId) {
      if(shippingId) {
        this.isLoadingASL = true
        this.input = {
          "XBkey": "XB123",
        	"ShippingID": shippingId,
        	"LastModifiedBy": this.createdBy,
        }
        axios({
            method: 'POST',
            url: apiUrl.api_url + 'expose/shipment/remove',
            data: this.input
          })
          .then(result => {
            if (result.data.code==200) {
              let TrackerInfo = {
                projectname:"Last Mile",
                type:"Web",
                userid:this.userid,
                username:this.createdBy,
                meta: {
                    "event" : "removeShipment",
                    "ShippingID": shippingId.toString()
                }
              }
              this.PageTracker(TrackerInfo);
              this.loadSrShipmentDetails()
              this.$alertify.success("Shipment Successfully Removed")
            } else {
              this.$alertify.error(result.data.message!='' && result.data.message!=undefined?result.data.message:'Not getting any response message.')
            }
            this.isLoadingASL = false
          }, error => {
            this.isLoadingASL = false
            console.error(error)
          })
      } else {
        this.$alertify.error("Shipment ID not found")
      }
    },
    isSameDayDelivery(flag) {
      var response = "No"
      if(flag) {
        var response = "Yes"
      }
      return response;
    },
    fullScreenPendingShipmentList() {
      this.pendingShipModel = true
      this.PopUpsearchByShippingId = '';
      this.pendingShipmentListMdl = '';
      //console.log('this.PendingListdeliveryOpt',this.PendingListdeliveryOpt);
      if(this.PendingListdeliveryOpt != 'RVP'){
        this.getAllPendingShipListOnFullSC(this.PendingListdeliveryOpt);
      }
      this.searchByShippingId = '';
    },
    closePendingShipModel() {
      this.pendingShipModel = false
      this.PopUpsearchByShippingId = '';
      this.pendingShipmentListMdl = '';
    },
    getPaginationDataModel(pageNum) {
      this.pageNoMdl = pageNum;
      this.loadPendingShipmentListModel(this.mdlPopDeliveryOption, this.pageNoMdl);
    },
    SearchPopShipmentDetails(e){
      if(event.keyCode === 13) {
        this.loadPendingShipmentListModel('','');
      }
    },
    getAllPendingShipListOnFullSC(legType){
      if (this.$refs.paginateForFullSC != undefined) {
        this.$refs.paginateForFullSC.selected= 0;
      }
      this.loadPendingShipmentListModel(legType)
    },
    loadPendingShipmentListModel(deliveryTabTypeOption, pageNoMdl = 1) {
      this.isLoadingPSLModel = true
      this.pendingShipmentListMdl = []
      this.pageNoMdl = pageNoMdl;
      if(this.deliveryOption != ''){
         this.mdlPopDeliveryOption = this.deliveryOption.toLowerCase() == 'rto/dto' ? 'RTO' : this.deliveryOption;
         this.isFlyerBarcodecheck(this.IsRVPPaperless,this.deliveryOption);
      }
      if(deliveryTabTypeOption != ''){
        this.mdlPopDeliveryOption = deliveryTabTypeOption;
        this.isFlyerBarcodecheck(this.IsRVPPaperless,deliveryTabTypeOption);
      }

      if(this.mdlPopDeliveryOption.toLowerCase() == 'delivery'){
          this.mdlPopDeliveryOption = 'Forward';
      }
      this.input = {
        "HubID": this.userHubId.toString(),
        "ShipmentType": this.mdlPopDeliveryOption,
        "PageNo":this.pageNoMdl
      }
      if(this.PopUpsearchByShippingId !="") {
        this.input["ShippingId"] = this.PopUpsearchByShippingId.trim()
      }
      axios({
        method: 'POST',
        url: apiUrl.api_url + 'expose/get/pending/shipment/details',
        data: this.input
      })
      .then(result => {
        if (result.data.code==200) {
          this.pendingShipmentListMdl = result.data.data
          this.totalPendingShipmentMdl = result.data.Total
          if (this.totalPendingShipmentMdl < 20) {
            this.pageCountMdl = 1
          } else {
            this.pageCountMdl = Math.ceil(this.totalPendingShipmentMdl / 20);
          }
        } else{
          this.pageCountMdl = 0
        }
        this.isLoadingPSLModel = false
      }, error => {
        this.isLoadingPSLModel = false
        console.error(error)
      })
    },
    selectSRFlt(obj) {
      this.srItemObjFlt = obj
      this.srIdFlt = obj.value
    },
    selectFromFlt(obj) {
      this.fromItemObjFlt = obj
      this.fromIdFlt = obj.value
      this.srShipmentPrintList = []
    },
    selectDeliveryOptionPrint(obj) {
      this.srShipmentPrintList = []
      this.batchIdListPrint = [];
      this.deliveryOptionItemObjPrint = obj;
      this.deliveryOptionPrint = obj.text;
      let fromrvpdate = moment().subtract(1, 'days').format('YYYY-MM-DD');
      let torvpdate = moment().format('YYYY-MM-DD');
      this.showconfirmPrint = false
    },
    printShipmentForDelivery() {
      this.srShipmentPrintList = []
      this.showconfirmPrint = false
      if(this.deliveryOptionPrint == ''){
        return this.$alertify.error('Please select Delivery Option');
      }
    //  if(this.deliveryOptionPrint == 'RVP' && this.batchIdPrint == ''){
    //    return this.$alertify.error('Please select Batch Id');
    //  }
      // this.printType = dType;
      // this.printDType = dType
      // if(dType=="delivery" && (this.deliveryOptionPrint=='RTO' || this.deliveryOptionPrint=='DTO')) {
      //   this.printDType = "printRTORunsheet";
      // } else if (dType=="delivery" && this.deliveryOptionPrint=='RVP') {
      //   this.printDType = "printRVP";
      // }
      // this.rtoDtoDrsTitle='RTO DRS';
      // this.rtoDtoSheetTitle='RTO Sheet';
      // if(this.deliveryOptionPrint=='DTO') {
      //   this.rtoDtoDrsTitle='DTO DRS';
      //   this.rtoDtoSheetTitle='DTO Sheet';
      // }
      this.srShipmentPrintList = []
      var selectedSrDtl = this.srArrayList.filter(n=>{
        return n.userid==this.srIdFlt
      })
      this.srNameShipPrint = selectedSrDtl[0].FirstName+" "+selectedSrDtl[0].LastName+" ("+selectedSrDtl[0].userid+")"
      this.srPhoneShipPrint = selectedSrDtl[0].MobileNumber?selectedSrDtl[0].MobileNumber.toString():""
      // if ((this.deliveryOptionPrint=='RVP' || this.deliveryOptionPrint=='RTO' || this.deliveryOptionPrint=='DTO')) {
        if(this.batchCreatedDate == ''){
          return this.$alertify.error('Please select Created Date');
        }
        this.batchIdListPrint = [];
        this.shippingIDArray = [];
        this.isLoadBatch = true;
        let batchCdate =  moment(this.batchCreatedDate).format('YYYY-MM-DD');
        this.today = new Date();
        let Today = moment(this.today).format('YYYY-MM-DD');
        if(batchCdate < Today){
          this.pastdate = true;
          this.futuredate = false;
        }
        else {
          this.futuredate = true;
          this.pastdate = false;
        }
        let batchpayload = {
          "UserHubID": this.userHubId.toString(),
          "DeliveryUserID": this.srIdFlt,
          "shipmentType":this.deliveryOptionPrint,
          "createdDate":batchCdate
          //"FromDate": fromrvpdate,
          //"ToDate": torvpdate
        }
        axios({
          method: 'POST',
          url: apiUrl.api_url + 'expose/get/batchid',
          data: batchpayload
        })
        .then(result => {
          console.log(result);
          if (result.data.code==200) {
            this.isLoadBatch = false
            for (var i = 0; i < result.data.PrintBatchId.length; i++) {
              this.shippingIDArray = []
              for(var j=0 ;j<result.data.PrintBatchId[i].NoOfShipments; j++){
                this.shippingIDArray.push({
                  shippingIDArray : result.data.PrintBatchId[i].ShippingIDs[j].ShippingID
                  })
                }
                  this.batchIdListPrint.push({
                    AssignBatchNo : result.data.PrintBatchId[i].AssignBatchNo,
                    NoOfShipments : result.data.PrintBatchId[i].NoOfShipments,
                   shippingIDArray : this.shippingIDArray
                  })
                }
              }
           else {
            this.isLoadBatch = false
            this.$alertify.error(result.data.message)
          }
        }, error => {
          console.error(error)
        })
//       }
//       else{
//         this.showconfirmPrint = true,
//         this.isLoadingPrint = true
//     //  this.fromIdFlt = this.fromItemObjFlt.value
//       this.input = {
//         "DeliveryUserID" : this.srIdFlt,
//         "PrintFrom": this.fromIdFlt,
//         "ShipmentType": this.deliveryOptionPrint
// //        "BatchId": this.batchIdPrint
//       }
//       axios({
//         method: 'POST',
//         url: apiUrl.api_url + 'expose/web/get/shipmentbysrid',
//         data: this.input
//       })
//       .then(async result => {
//         if (result.data.code==200) {
//           this.srShipmentPrintList = result.data.data
//           // this.RVPLink = result.data.RVPRunsheetPDFLink;
//           // this.apiPath = await apiUrl.api_url +'expose/web/get/pdf?Filename='+this.RVPLink;
//           // pathPDF = this.apiPath
//
//           if(this.srShipmentPrintList.length>0) {
//             this.rtoDRSBatchId=this.srShipmentPrintList[0].AssignBatchNo
//             this.rtoDRSClientName=''
//             this.rtoDRSVendorName=this.srShipmentPrintList[0].RTOName
//             this.rtoDRSWHHandOverPersonName=''
//             this.rtoRunSTHubName=this.srShipmentPrintList[0].HubName
//             this.rtoRunSTDrsNo=this.srShipmentPrintList[0].AssigneBatchNo
//           }
//           // if(this.deliveryOptionPrint=='RVP'){
//           //    alert("Generating PDF...! Please Wait to open...")
//           //    setTimeout(function(){
//           //      window.open(pathPDF);
//           // }, 5000);
//           //  }
//         } else {
//           this.$alertify.error(result.data.message)
//         }
//         this.isLoadingPrint = false
//       }, error => {
//         console.error(error)
//       })
//     }
    },
    printShipmentForRVP(AssignBatchNo,pdfType){
      let responseType = 'blob';
      this.srShipmentPrintList = []
      this.isLoadPDF = true

      this.input = {
        "DeliveryUserID" : this.srIdFlt,
      //  "PrintFrom": this.fromIdFlt,
        "ShipmentType": this.deliveryOptionPrint,
        "BatchId": AssignBatchNo,
      //  "PrintType":pdfType,
        "UserName":this.createdBy
      }
      if(pdfType == 'olddrs'){
        this.input.SheetType = pdfType
      }
      else {
        this.input.PrintType = pdfType
      }
      if(this.deliveryOptionPrint == "Delivery"){
        this.input.PrintFrom = 'FromWeb';
      }
      axios({
        method: 'POST',
        url: apiUrl.api_url + 'expose/web/get/shipmentbysrid',
        data: this.input,
        responseType: responseType
      })
      .then(async result => {
           if(result.status == 200 ) {
            this.downloadUrl = window.URL.createObjectURL(new Blob([result.data], { type: 'application/pdf' }))
            
             if (['rto', 'dto'].includes(this.deliveryOptionPrint.toLowerCase()) && pdfType == 'vendor') {
               this.drsbatchdetails = result.headers['batchid'] || '0';
               this.drsshipmentdetails = result.headers['shipment'] || '0';
               this.isLoadPDF = false;
               this.openDRSModel = true;
             } else {
               let message = {
                 title: '',
                 body: `<p>Pdf is generated, Would you like to open.!</p>`,
               };

               let res = this.$dialog.alert(message, {
                 html: true,
                 animation: 'bounce',
                 backdropClose: false,
                 loader: true
               })
                 .then(dialog => {
                   window.open(this.downloadUrl);
                   this.isLoadPDF = false
                   dialog.close();
                 })
                 .catch(() => {
                   this.isLoadPDF = false
                 })
             }
          } else {
            this.isLoadPDF = false;
            this.$alertify.error('PDF not generated because OTP is mandatory for all batches..!');
          }
      }, error => {
        this.isLoadPDF = false;
        console.error(error)
      })
    },
    exportCSVOfShippingIDS(result) {
      let csvContent = "data:text/csv;charset=utf-8,";
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1;
      var yyyy = today.getFullYear();
      var today = dd + "" + mm + "" + yyyy;
      let filename = "ShippingID" + today + ".csv";
      csvContent += ['ShippingID',
    //    Object.keys(result).join(";"),
        ...result.map(item => Object.values(item).join(";"))
      ]
      .join("\n")
      .replace(/(^\[)|(\]$)/gm, "");

      const data = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", filename);
      link.click();
    },
    // printShipments() {
    //   const d = new Printd();
    //   var buffer = '';
    //
    //   var cssText = `
    //        body{
    //            -webkit-print-color-adjust:exact;
    //            font-family: Roboto,sans-serif;
    //        }
    //        table {
    //            border-collapse: collapse;
    //            margin-left:0px !important;
    //        }
    //        table, td, th {
    //          border-style: solid;
    //          border-width: 1px;
    //          padding:2px;
    //        }
    //        .text-right{
    //          text-align:right;
    //        }
    //        .text-left{
    //          text-align:left;
    //        }
    //        .td-width{
    //          width:10px!important;
    //        }
    //        .text-center{
    //          text-align:center;
    //        }
    //        .h3-center-text{
    //          text-align:center;
    //        }
    //
    //
    //        .tbl-fs16 {
    //          font-size:16px;
    //          font-weight:bold
    //        }
    //        td span {
    //          font-size:14px !important;
    //        }
    //
    //        @media print {
    //        .text-primary th{
    //          background-color:rgb(226, 216, 216) !important;
    //          color:black !important;
    //          font-size:20px !important;
    //        }
    //        .pagebreak { page-break-before: always; }
    //       }
    //       `
    //   d.print(document.getElementById('printShipmentContent'), cssText);
    // },
    printShipDateTime() {
      return moment().format('DD-MM-YYYY') +" @ "+ moment().format('HHmm')
    },
    currentDate() {
      return moment().format('DD-MM-YYYY');
    },
    currentTime() {
      return moment().format('HH:mm:ss');
    },
    closeShipmentModel() {
      this.showShipmentModel=false
    },
    ShowShipments() {
      this.showShipmentModel = true
      this.isPodsLoader = true;
      this.showShipmentList = []
      this.input = {
        "DeliveryUserId": this.srId
      }
      axios({
        method: 'POST',
        url: apiUrl.api_url + 'expose/shipment/previous',
        data: this.input
      })
      .then(result => {
        if (result.data.code==200) {
          this.showShipmentList = result.data.data
        } else {
          this.$alertify.error(result.data.message!='' && result.data.message!=undefined?result.data.message:'Not getting any response message.')
        }
        this.isPodsLoader = false;
      }, error => {
        console.error(error)
      })
    },
    clearTrip(){
      this.isShowDummyInput = false;
      this.$refs.dummyShipInputBox.clearStyles();
      this.$refs.dummyShipInputBox2.clearStyles();
      // this.loadSRList(this.userHubId);
      let clearStatus = this.resetTrip();
      this.isResetLoad = true;
      if(clearStatus){
        console.log('lodaer off',clearStatus);
        this.isResetLoad = false;
      }
      if(this.setLocusFlag){
        this.getAllPendingShipmentList('reload','RTO')
      }
      this.hideAllocateFlag=true;
      this.$validator.reset();
    },
    resetTrip() {
      this.isVehicleReplacedCheck = 0
      this.isVehicleReplaced=false
      this.errVehicleNo = ""
      this.errVehicleKm = ""
      this.tripTitle = 'Start Trip'
      this.isRSVSr = 0
      this.srId = ''
      this.srName = ''
      this.srItemObj = { value: "",text: ""}
      this.startTripFlag = false
      this.vehicleTypeFlag = false
      this.vehicleType = ""
      this.vehicleNoItemObj = {value:'', text: ''}
      this.vehicleNo = ''
      this.vehicleVendorId = 0
      this.vehicleOpenKM = ''
      this.startAllocationFlag = false

      this.deliveryOptionItemObj = { text: ""}
      this.deliveryOption = ""
      this.clientOptionItemObj = {value: "",text: ""}
      this.clientOption = ""
      this.shipmentNo = ''
      this.isAllocation = false
      this.fromItemObj = { value: "UA",text: "From Mobile"}
      this.fromId = "UA"

      this.tripId = ''
      this.openKm = ''
      this.openKmImg = ''
      this.closeKm = ''
      this.closeKmImg = ''
      this.originCloseImg = ''
      this.latitude = ''
      this.longitude = ''
      this.srVehicleNo = ''
      this.errorCloseKM = ''
      this.errorOpenKM = ''

      this.srShipmentList = []
      this.flagShowPreviousShipment = false

      this.fromToDate= ''
      this.fltpickup= 'Pending'
      this.selectedPickups= []
      this.selectedPickupsMore=[]
      this.pendingShipmentList = []
      this.totalPendingShipment = 0
      this.currentDateTime = '',
      this.tripDayflag = '',
      this.tripCreatedDate = '',
      this.tripDateFlag = false,
      this.IsSRNeedTrip = true,
      this.searchByShippingIdRvp = '',
      this.isShowCODAmount = false;
      this.srCODPendingMsg = '';
      this.clientcheck = false,
      this.triggeredByDialog = false
      // this.resetBulkAllocation()
      return true;
    },
    selectAll() {
      if (this.sAll) {
        let searchedShipments = []
        if(this.SearchpickupList.length > 0){
          searchedShipments = this.SearchpickupList
        }else {
          searchedShipments = this.pickupList
        }
        searchedShipments.forEach((data) => {
          this.selectedPickups.indexOf(data.ShippingId) == -1 ? this.selectedPickups.push(data.ShippingId) : ''
        })
      } else {
        this.selectedPickups = []
      }
    },
    selectAllMoreRVPShipments() {
      if (this.sAllMoreShip) {
        this.suggestRVPArrayList.forEach((data) => {
          this.selectedPickupsMore.indexOf(data.ShippingId) == -1 ? this.selectedPickupsMore.push(data.ShippingId) : ''
        })
      } else {
        this.selectedPickupsMore = []
      }
    },
    closeRvpShipmentsModel() {
      this.tabIndex = 0;
      this.clientOptionItemObj = {value: "",text: ""}
      this.clientOption = ""
      this.deliveryOptionItemObj = { text: ""}
      this.deliveryOption = ""
      this.$validator.reset();
      this.rvpShipmentsModel = false;
      this.searchByShippingIdRvp = ""
    },
    showPendingPickups() {
      this.isLoadingPSL = true
      this.PendingPopTabOptionKey = 1;
      if(this.setLocusFlag == true){
        this.PendingTabOptionKeyForLocus = 0;
        this.PendingPopTabOptionKeyForLocus = 0;
      }
      this.PendingListdeliveryOpt = 'RVP';
      this.indexTab = 1;
      this.fromId="UA",
      this.fromItemObj = { value: "UA",text: "From Mobile"}
      this.isLoadingRvpPickup = true
      this.errorRvpAllocation = '';
      this.successRvpAllocation = '';
      this.pickupList = []
      this.selectedPickups = []
      this.selectedPickupsMore = []
      this.morePendingRVPShipmentsModel = false
      this.isActiveRvp=false
      this.sAll = ''
      this.fromDate = null;
      this.toDate = null;
      this.isFlyerBarcodecheck(this.IsRVPPaperless,this.PendingListdeliveryOpt);
      if(this.fromToDate) {
        this.fromDate = this.fromToDate[0]?moment(this.fromToDate[0]).format('YYYY-MM-DD'):null;
        this.toDate = this.fromToDate[1]?moment(this.fromToDate[1]).format('YYYY-MM-DD'):null;
      }
      this.input = {
        "hubid": this.userHubId,
        "shipmenttype": "Reverse",
        "status": this.fltpickup,
        "clientbusinessdetailid": null,
        "FromDate": this.fromDate,
        "ToDate": this.toDate
      }
      axios({
        method: 'POST',
        url: apiUrl.api_url + 'expose/shipment/reversepending/list',
        data: this.input
      })
      .then(result => {
        if (result.data.code==200) {
          this.isLoadingPSL = true
          this.pickupList = result.data.data;
          this.SearchpickupList = result.data.data;
        } else {
          this.isLoadingPSL = true
          this.pickupList = [];
          this.SearchpickupList = [];
          this.$alertify.error(result.data.message!='' && result.data.message!=undefined?result.data.message:'Not getting any response message.')
        }
        this.isLoadingRvpPickup = false
      }, error => {
        this.isLoadingPSL = true
        this.isLoadingRvpPickup = false
        console.error(error)
      })
    },
    loadRVPAllocatedShipmentList(){
      this.indexTab = 2
      this.RVPAllocatedShipmentList = [];
      //this.srShipmentList = []
      if(this.srId) {
        this.isLoadingASL = true
        this.input = {

          "HubId": this.userHubId.toString(),
          "DeliveryUserId": this.srId
        }
        if(this.deliveryOption!="") {
          this.input["ShipmentType"] = this.deliveryOption
        }
        // if(this.searchByShippingId !="") {
        //   this.input["ShippingId"] = this.searchByShippingId
        // }
        //console.log('this.input',this.input);
        axios({
          method: 'POST',
          url: apiUrl.api_url + 'expose/get/allocate/shipment/sr/details',
          data: this.input
        })
        .then(result => {
          if (result.data.code==200) {
            this.RVPAllocatedShipmentList = result.data.data;
            if(this.RVPAllocatedShipmentList.length >= 1) {
              this.isAllocationRvp = true
            }
          } else {

            this.isAllocationRvp = false
          }
          this.isLoadingASL = false
        }, error => {
          this.isLoadingASL = false
          console.error(error)
        })
      }
    },
    selectPickups(obj) {
      this.pickupItem = obj
      this.fltpickup = obj.value
    },
    checkPendingForRVP() {

      this.selectedPickupsMore=[]
      this.getPendingForRVPList().then( (result) => {
        if(result.success) {
          this.morePendingRVPShipmentsModel = true
          this.isActiveRvp=true
        } else {
          this.allocatePickup()
        }
      });
    },
    preMPSValidationCheck() {
      this.getSameMPSGroupShipments().then( (result) => {
        if(result.success) {
          this.morePendingRVPShipmentsModel = true
          this.isActiveRvp=true
          if(this.IsrvpMPSAllocation) {

            let mpsGroupShipments = this.holdTempMPSData
            let mpsCount = mpsGroupShipments.length
            if(mpsGroupShipments.length > 0) {
              let filterArray = mpsGroupShipments.filter(person => this.selectedPickupsMore.includes(person.ShippingId) );
              if(filterArray.length == mpsGroupShipments.length) {
                console.log('Proceed For Success.!!!!!!!!!!');
                this.allocatePickup()
              } else {
                this.$alertify.error('Please allocate same mps shipment to one SR.!')
              }
            } else {
              this.allocatePickup()
              console.log('Proceed Without MPS Success.!!!!!!!!!!');
            }
            // let mpsGroupShipments = this.holdTempMPSData
            // if(mpsGroupShipments.length > 0) {
            //   mpsGroupShipments.forEach((val,idx) => {
            //     let removeElement = this.selectedPickupsMore.find(selectedObj => selectedObj == val.ShippingId)
            //     if(removeElement) {
            //       console.log('removeElement ==============>>', removeElement);
            //       mpsGroupShipments.splice(idx, 1);
            //     }
            //   })
            //   console.log('this.holdTempMPSData ==========================>>>>', this.holdTempMPSData);
            //   if(mpsGroupShipments.length == 0) {
            //     console.log('MY TARGET IS Achieved.!!!!!!!!!!!!!!!!!');
            //   }
            // } else {
            //   console.log('ELSE MEANS NO SELECTED.....!!!!!!!!!!!!!!!!!!!!!!!!!!!');
            // }
          }
        } else {
          // console.log('Allocation Is Performing TRIGGERED .!');
          this.allocatePickup()
        }
      });
    },
    async allocatePickup() {
      let validateUser = await this.validateJwtToken()
      this.selectedPickups = this.selectedPickups.concat(this.selectedPickupsMore)
      var self = this;
      this.errorRvpAllocation = "";
      this.successRvpAllocation = '';
      this.errorRvpAllocationErrorArrobj = [];
      this.ShipmentFutureFailedArrObj = [];
      this.ShipmentFailedArrObj = [];
      this.rvpPrexoShipmentList = [];
      if(this.selectedPickups.length>0) {
        this.isLoadingRvpPickup = true
        this.resArray = [];
        var successCount = 0;
        var failCount = 0;
        var failCountFutureDate = 0;
        var failShipmentsFDArray = [];
        var failShipmentsArray = [];

        let chain = Promise.resolve();
        for(let val of this.selectedPickups) {
          chain = chain.then(() => self.bulkAllocation(val));
        }
        chain.then(() => {
          var result = this.resArray
          //console.log('result',result);
          for (var i = 0; i < result.length; i++) {
            if (result[i].statusCode==206) {
              failShipmentsFDArray.push(result[i].shippingId)
              failCountFutureDate++;
                this.ShipmentFutureFailedArrObj.push(result[i]);
            } else if (result[i].statusCode==200) {
              successCount++;
              if(result[i].prexoShipment){
                this.rvpPrexoShipmentList.push(parseInt(result[i].prexoShipment));
              }
            } else {
              failCount++;
              this.ShipmentFailedArrObj.push(result[i]);
            }
          }
          if(failCount>0) {
            self.errorRvpAllocation = failCount+" shipping ids cannot assign for pickup."
            this.errorRvpAllocationErrorArrobj = this.ShipmentFailedArrObj;
          }
          if(failCountFutureDate>0) {
            self.errorRvpAllocation = failCountFutureDate+" these shipping ids cannot assign for pickup, because pickup date set as a future date.";
            this.errorRvpAllocationErrorArrobj = this.ShipmentFutureFailedArrObj;
          }
          if(successCount>0) {
            this.isAllocationRvp = true;
            this.morePendingRVPShipmentsModel = false
            this.isActiveRvp=false
            self.successRvpAllocation = successCount+" shipments allocated successfully";
            this.loadRVPShipmentDetails()
          }
          this.isLoadingRvpPickup = false;
        }).catch(err=>{
          console.log('promise Error', err);
          self.errorRvpAllocation = err.message;
          this.isLoadingRvpPickup = false;
        });
      }
    },
    bulkAllocation(shippingId) {
      // if($("#CI"+shippingId).val()!=undefined && $("#CI"+shippingId).val()!="") {
      //   var clientId = $("#CI"+shippingId).val();
        return new Promise( (resolve, reject) => {
          if($("#CI"+shippingId).val()!=undefined && $("#CI"+shippingId).val()!="") {
            var clientId = $("#CI"+shippingId).val();

          this.files = []
          var selectedSrDtl = this.srArrayList.filter(n=>{
            return n.userid==this.srId
          })
          this.input = {
            "XBkey":"XB123",
          	"HubId":this.userHubId.toString(),
          	"DeliveryUserId":this.srId,
          	"OldDeliveryUserOrUserId":selectedSrDtl[0].OldDeliveryUserOrUserId?selectedSrDtl[0].OldDeliveryUserOrUserId.toString():"0",
          	"DeliveryUserName":this.srName,
          	"ShippingID":shippingId,
          	"LastModifiedBy":this.createdBy,
          	"IsConfirmAllocation":false,
          	"AllocationType":this.deliveryOption,
            "EmpType":selectedSrDtl[0].EmpType?selectedSrDtl[0].EmpType:"",
          	"MarkedFrom":"Web",//this.fromId,
          	"CourierCompanyID":selectedSrDtl[0].CourierCompanyID?selectedSrDtl[0].CourierCompanyID.toString():'null',
          	"IsRSVCSr":this.isRSVSr,
          	"MobileNo":selectedSrDtl[0].MobileNumber?selectedSrDtl[0].MobileNumber.toString():"",
            "isTripAllowedForSR": this.IsSRNeedTrip,
            "IsRVPPaperless": this.IsRVPPaperless
          }
          if(this.deliveryOption!="Delivery") {
            this.input["ClientId"] = clientId
          }
          axios({
            method: 'POST',
            url: apiUrl.api_url + 'expose/shipment/allocate',
            data: this.input
          })
          .then(result => {
            var result = result.data
            //Hundle Prexo shipment error and succes msg
            let finalObjOfErrorOrSuccess = {"success":false, "statusCode":result.status, "message":result.message, "shippingId":shippingId}
            if(result.prexoShipment){
              finalObjOfErrorOrSuccess['prexoShipment']=result.prexoShipment
            }

            if(result.status==204) {
              //Hundle Prexo shipment error
              this.resArray.push(finalObjOfErrorOrSuccess);
              resolve({"success":false, "statusCode":result.status, "message":result.message, "shippingId":shippingId});
              //reject({"success":false, "statusCode":result.status, "message":result.message, "shippingId":shippingId});
            } else if (result.status==206) {
              this.resArray.push(finalObjOfErrorOrSuccess)
              resolve();
            } else if (result.code==200) {
              $("#rvpTr"+shippingId).remove();
              let TrackerInfo = {
                projectname:"Last Mile",
                type:"Web",
                userid:this.userid,
                username:this.createdBy,
                meta: {
                    "event" : "bulkAllocation",
                    "HubId":this.userHubId.toString(),
          	        "DeliveryUserId":this.srId,
                    "ShippingID":shippingId.toString()
                }
              }
              this.PageTracker(TrackerInfo);
              for (var i = 0; i < this.selectedPickups.length; i++) {
                if(this.selectedPickups[i]==shippingId) {
                  this.selectedPickups.splice(i, 1);
                }
              }
              finalObjOfErrorOrSuccess.success = true;
              finalObjOfErrorOrSuccess.statusCode = result.code;
              this.resArray.push(finalObjOfErrorOrSuccess)
              resolve();
            } else {
              finalObjOfErrorOrSuccess.statusCode = result.code;
              this.resArray.push(finalObjOfErrorOrSuccess)
              resolve();
            }
          }, error => {
            console.log('Catch Exception has been prited : - ', error)
            this.resArray.push({"success":false, "statusCode":'502', "message":"server error, Try later", "shippingId":shippingId})
            resolve();
          })

          } else {
            this.resArray.push({"success":false, "statusCode":'502', "message":"Selected shipment not found", "shippingId":shippingId})
            resolve();
          }
        })
      // } else {
      //   resolve({"success":false, "statusCode":null, "message":"ClientId not found"});
      // }
    },
    getSameMPSGroupShipments() {
      this.IsrvpMPSAllocation = false
      return new Promise((resolve, reject) => {
        // console.log('selectedPickups ========>>>>>>>>>', this.selectedPickups);
        let holdTempData = []
        this.holdTempMPSData = []
        let len = this.selectedPickups.length;
        for(let i = 0; i< len; i++) {
          let getObj = this.pickupList.find(obj => obj.ShippingId == this.selectedPickups[i])
          if(getObj && getObj != 'undefined'){
            let mpsShipments = this.pickupList.forEach(mpscheck => {
              if (mpscheck.MultiShipmentGroupID != '' && mpscheck.MultiShipmentGroupID != null && mpscheck.MultiShipmentGroupID != 'null' &&  mpscheck.MultiShipmentGroupID == getObj.MultiShipmentGroupID) {
                if(!this.selectedPickups.includes(mpscheck.ShippingId)) {
                  if(this.holdTempMPSData.length>0){
                    let isExist = this.holdTempMPSData.find(o=>o.ShippingId == mpscheck.ShippingId)

                    if (isExist){
                    }else{
                      this.holdTempMPSData.push(mpscheck);

                    }

                  }else {this.holdTempMPSData.push(mpscheck);}

                }
              }
            })
          }
        }

        if(this.holdTempMPSData.length > 0) {
          this.IsrvpMPSAllocation = true
          this.suggestRVPArrayList = this.holdTempMPSData
          resolve({success:true});
        } else {
          this.IsrvpMPSAllocation = false
          resolve({success:false});
        }
      })
    },
    getPendingForRVPList() {
      this.errorRvpAllocation = "";
      this.successRvpAllocation = '';
      return new Promise( (resolve, reject) => {
        this.suggestRVPArrayList = []
        var relShippingIds = []
        axios({
          method: 'POST',
          url: apiUrl.api_url + 'expose/get/rvp/shipments',
          data: {ShippingID:this.selectedPickups}
        })
        .then(response => {
          var resultData = response.data
          if(resultData.code == 200 && typeof resultData.data !== 'undefined') {
            var result = resultData.data
            for (var i = 0; i < result.length; i++) {
              if(result[i].ReversePickUpData.length>0) {
                let tempData = result[i].ReversePickUpData
                for (var j = 0; j < tempData.length; j++) {
                  relShippingIds.push(tempData[j])
                }
              }
            }
            if(relShippingIds.length>0) {
              for (var i = 0; i < relShippingIds.length; i++) {
                for (var j = 0; j < this.selectedPickups.length; j++) {
                  if(relShippingIds[i]==this.selectedPickups[j]) {
                    relShippingIds.splice(i,1);
                  }
                }
              }
              var uniqueArray = []
              for (var i = 0; i < relShippingIds.length; i++) {
                if(uniqueArray.indexOf(relShippingIds[i]) === -1) {
                  uniqueArray.push(relShippingIds[i]);
                }
              }

              var suggestRVPArrayList=[]
              for (var i = 0; i < this.pickupList.length; i++) {
                if(uniqueArray.includes(this.pickupList[i].ShippingId)) {
                  this.suggestRVPArrayList.push(this.pickupList[i]);
                }
              }
              resolve({success:true});
            }
          } else {
            resolve({success:false});
          }
        }, error => {
          resolve({success:false});
        })
      });
    },
    closeMPRVPShipments() {
      this.morePendingRVPShipmentsModel = false
      this.isActiveRvp=false
      this.errorRvpAllocation=''
      this.successRvpAllocation=''
      this.sAll = ""
      this.sAllMoreShip = ""
      this.selectedPickups = []
      this.selectedPickupsMore = []
    },
    resetBulkAllocation() {
      this.fromToDate= ''
      this.fltpickup= 'Pending'
      this.selectedPickups= []
      this.selectedPickupsMore = []
      this.pickupList= []
      this.pickupItem= {value:'Pending',text:'All Pending'}
    },
    loadRVPShipmentDetails(){
      this.sAll = ""
      this.sAllMoreShip = ""
      this.selectedPickups = []
      this.selectedPickupsMore = []

      var searchvalue = this.searchByShippingIdRvp.toLowerCase();
      // let shipments = this.pickupList.filter(shipment => {
      //   return (
      //     (shipment.ShippingId && shipment.ShippingId.toLowerCase().indexOf(searchvalue) !== -1) ||
      //     (shipment.ClientName && shipment.ClientName.toLowerCase().indexOf(searchvalue) !== -1) ||
      //     (shipment.CustomerFirstName && shipment.CustomerFirstName.toLowerCase().indexOf(searchvalue) !== -1) ||
      //     (shipment.CustomerCity && shipment.CustomerCity.toLowerCase().indexOf(searchvalue) !== -1) ||
      //     (shipment.CustomerAddress && shipment.CustomerAddress.toLowerCase().indexOf(searchvalue) !== -1) ||
      //     (shipment.CustomerPinCode && shipment.CustomerPinCode.toString().toLowerCase().indexOf(searchvalue) !== -1)
      //   );
      // });
      let shipments = this.pickupList.filter(shipment => {
        return Object.keys(shipment).some(key => {
          let value = shipment[key];
          if (value) {
            return value.toString().toLowerCase().includes(searchvalue);
          }
          return false;
        });
      });
      this.SearchpickupList = shipments;
    },
    loadRVPAllocatedShipmentDetails(){
      var searchallocated = this.searchByShippingIdRvpASL.toLowerCase();
      $("#shipmentListRvpAllocated tbody tr").filter(function() {
        $(this).toggle($(this).text().toLowerCase().indexOf(searchallocated) > -1)
      });
      this.sAll = ""
      this.sAllMoreShip = ""
      this.selectedPickups = []
      this.selectedPickupsMore = []
    },
    selectBatchIdPrint(obj) {
      this.batchIdItemObjPrint = obj
      this.batchIdPrint = obj.text;
      this.srShipmentPrintList = []
    },
    resetPrint(){
        this.deliveryOptionItemObjPrint = '';
        this.srItemObjFlt = ''
        this.srIdFlt = false
        this.deliveryOptionPrint = ''
        this.srShipmentPrintList = []
        this.isLoadBatch = false
        this.isLoadingPrint = false
        this.batchIdListPrint = []
        this.batchCreatedDate = ''
        this.showconfirmPrint = false;
    },
    checkOptionTypeForTab(optType){
      for (let index = 0; index < this.deliveryOptionListTab.length; index++) {
        const element = this.deliveryOptionListTab[index].text;
         if(element.toLowerCase() == optType) {
          this.PendingTabOptionKey = index;
         }
      }
    },

    checkOptionTypeForTabForLocus(optType){
      for (let index = 0; index < this.deliveryOptionListTab.length; index++) {
        const element = this.deliveryOptionListTab[index].text;
         if(element.toLowerCase() == optType) {
          this.PendingTabOptionKeyForLocus = index;
         }
      }
    },
    async validateEODAllocation(deliveryuserid,hubid){
      return new Promise((resolve, reject) =>{
        this.hideAllocateFlag=true;
        this.input = {
          "DeliveryUserID": parseInt(deliveryuserid, 10),
          "HubID": hubid,
        }
        axios({
          method: 'POST',
          url: apiUrl.api_url + 'DayEndClosure/validateEODAllocation/deliveryuserid',
          data: this.input
        })
        .then(result => {
          if (result.data.code === 202) {
            this.hideAllocateFlag=false;
            resolve(result.data.message);
          }else{
            this.hideAllocateFlag=true;
            resolve(false);
          }
        })
      })
    },
    handleDragOver(event){
      event.preventDefault();
    },
    // For RVP Heavies shipment show popup
    selectReason(obj) {
      this.ReasonObj = obj;
      this.Reason = obj.text
    },
    CheckPDD() {
      if([614,3586,3550].includes(this.userHubId)){
          this.CloseNonAllocationRsn()
          let Payload = {
            "DeliveryUserId": this.srId,
            "HubId": this.userHubId.toString(),
            "shipmenttype": "RVP",
          }
          GetNonAllocationSEQ(Payload, (result) => {
            if (result.data.code == 200 && result.data.data.length > 0) {
              this.SeqArray = result.data.data.filter(x => (x.result != 0))
              this.BucketName = this.SeqArray[0].Bucket
              this.TitleName = this.SeqArray[0].title
              if(this.BucketName == 'Heavies'){
                var splitStringArray = this.TitleName.split('_')
                this.heaviesTitleName1 = splitStringArray[0] ;
                this.heaviesTitleName2 = splitStringArray[1]
              }
              this.resultCount = this.SeqArray[0].result
              this.SEQShippingids = this.SeqArray[0].shippingids
              this.arrReasonList = this.SeqArray[0].Reason.split(",")
              for (let i = 0; i < this.arrReasonList.length; i++) {
                this.ReasonList.push({
                  text: this.arrReasonList[i],
                })
              }
              // this.rvpShipmentsModel = false
              this.NonAllocationRsn = true
            } else {
              this.confirmTrip();
              this.CloseNonAllocationRsn()
            }
          })
      }else{
        this.confirmTrip();
      }
    },
    CloseNonAllocationRsn() {
      this.BucketName = ''
      this.TitleName =''
      this.Reason = ''
      this.ReasonObj = {
          text: ""
      }
      this.resultCount = 0,
      this.SEQShippingids =[]
      this.ReasonList = []
      this.NonAllocationRsn = false
    },
    SubmitNonAllocationRsn() {
      let Payload = {
          "DeliveryUserId": this.srId,
          "Reason": this.Reason,
          "Bucket": this.BucketName,
          "CreatedBy": this.createdBy,
          "shippingids": this.SEQShippingids,
          "pendingcount": this.resultCount
      }
      StoreReason(Payload, (result) => {
          if (result.data.code == 200) {
              this.$alertify.success("Reason Submitted Successfully!!")
              this.CloseNonAllocationRsn();
              this.SeqArray.splice(0, 1)
              if(this.SeqArray.length>0){
                  this.StoreNonAllocationSeq();
              }
              else{
                this.confirmTrip();
              }
          } else if(result.data.code == 204){
             this.$alertify.error('Reason is required.')
          }
      })
    },
    StoreNonAllocationSeq() {
      this.CloseNonAllocationRsn();
      this.TitleName = this.SeqArray[0].title
      this.BucketName = this.SeqArray[0].Bucket
      this.resultCount = this.SeqArray[0].result
      this.SEQShippingids = this.SeqArray[0].shippingids
        this.arrReasonList  = this.SeqArray[0].Reason.split(",")
      for (let i = 0; i < this.arrReasonList .length; i++) {
          this.ReasonList.push({
              text: this.arrReasonList [i],
          })
      }
      this.NonAllocationRsn = true
    },
    SubmitHeavies(){
      this.CloseNonAllocationRsn();
      this.SeqArray.splice(0, 1)
      if(this.SeqArray.length>0){
          this.StoreNonAllocationSeq();
      }else{
        this.confirmTrip();
      }
  },
    CloseDRSModel() {
      this.openDRSModel = false;
      this.drsbatchdetails = '';
      this.drsshipmentdetails = '';
      this.downloadUrl = '';
    },
    openDRSAndClose() {
      if (this.downloadUrl) {
        window.open(this.downloadUrl, '_blank');
      }
      this.CloseDRSModel(); // your modal close function
    },

    onTabActivated(tabName) {
      this.activeTab = (tabName == "RTO/DTO" ? "RTO" : tabName);  // set active tab
      const selected = tabName.toLowerCase();

      switch (selected) {
        case 'delivery':
          this.getAllPendingShipmentList('reload', 'delivery');
          break;

        case 'dto':
          this.getAllPendingShipmentList('reload', 'DTO');
          break;

        case 'rto':
          this.getAllPendingShipmentList('reload', 'RTO');
          break;

        case 'rvp':
          this.showPendingPickups();
          break;

        case 'rto/dto':
          this.getAllPendingShipmentList('reload', 'RTO');
          break;
      }
    },

    selfPickupClientDialog() {
      let message = {
        title: '',
        body:
          `<div style="text-align: center;">
            <p><strong>This shipment is for self-pickup and should be allocated only while handing over.</strong></p>
            <p><strong>Are you sure you want to allocate?</strong></p>
          </div>`
      };

      let res = this.$dialog.confirm(message, {
        html: true,
        animation: 'bounce',
        backdropClose: false,
        okText: 'Yes',
        cancelText: 'No',
        reverse: false,
        loader: true
      })
        .then(dialog => {
          this.isLoadingAlc = true
          this.flagShowPreviousShipment = false
          this.clientcheck= true;
          this.triggeredByDialog = true;
          this.allocation();
          dialog.close()
          })
        .catch();
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/Allocation/Allocation.js